



































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeCadastroMedicoStore from '@/components/Backoffice/Store/BackofficeCadastroMedicoStore'
import CadastroMedicoStore from '@/components/CadastroMedico/store/CadastroMedicoStore'
import SegurancaApi from '@/Apis/Seguranca/Services/SegurancaApi'
import { validateEmail, validateCPF, validateLength, getUfs, onlyNumber } from '@/utils/common'
import { StatusEmailEnum } from '@/types/_'
import EventBus from '@/plugins/EventBus'

@Component

export default class ComponentBackofficeMedicosCadastradosForm extends Vue {
  $refs!: { formCadastro: any }

  ufs: any[] = [...getUfs()]

  cadastroMedicoRules: any = {
    valid: true,
    nome: [(v: any) => this.validateName(v)],
    emailPrincipal: [(v: any) => this.validateMainEmail(v)],
    emailsSecundarios: [(v: any) => this.validateSecondaryEmail(v)],
    cpf: [(v: any) => this.validateCpfField(v)],
    conselhoTipo: [(v: any) => !!v || 'Campo obrigatório.'],
    conselhoNumero: [(v: any) => !!v || 'Campo obrigatório.'],
    conselhoUf: [(v: any) => (!!v && v.length > 0) || 'Campo obrigatório.'],
    especialidade: [(v: any) => (!!v && !!v.length) || 'Campo obrigatório.'],
  }

  onlyNumberUtil(value) {
    return onlyNumber(value)
  }

  resetFormCadastro() {
    this.getBackofficeCadastroMedicoStore.clearCadastroMedicoBackoffice()
    this.emailPrincipalErrors = []
    this.emailsSecundariosErrors = []
    this.cpfErrors = []
    this.$refs.formCadastro.reset()
    // Hack para limpar os e-mails secundários...
    if (this.getBackofficeCadastroMedicoStore.cadastroMedicoBackoffice.emailsSecundarios.length) this.removeEmailsSecundarios(0)
  }

  removeEmailsSecundarios(index: number) {
    this.getBackofficeCadastroMedicoStore.removeEmailsSecundarios(index)
  }

  addEmailsSecundarios() {
    this.getBackofficeCadastroMedicoStore.addEmailsSecundarios('')
  }

  validateName(nome: any) {
    if (['', null, undefined].includes(nome)) return 'Campo obrigatório.'
    if (!validateLength(nome, 8)) return 'O campo deve ter pelo menos 8 caracteres.'
    return false
  }

  validateMainEmail(email: any) {
    if (['', null, undefined].includes(email)) return 'Campo obrigatório.'
    if (!validateEmail(email)) return 'Digite um e-mail válido.'
    return false
  }

  validateSecondaryEmail(email: any) {
    if (!['', null, undefined].includes(email)) {
      if (!validateEmail(email)) return 'Digite um e-mail válido.'
      if ([this.cadastroMedico.emailPrincipal].includes(email)) return 'E-mail duplicado.'
    }
    return false
  }

  emailPrincipalErrors: string[] = []
  emailsSecundariosErrors: string[] = []
  cpfErrors: string[] = []

  @Watch('cadastroMedico.emailsSecundarios')
  async onChangeCadastroMedicoEmailsSecundarios(value) {
    if (validateEmail(value[0])) {
      this.loadingEmailsSecundarios = true
      const getByLoginResponse = await SegurancaApi.getByLogin(value[0])
      if (getByLoginResponse.success) {
        this.emailsSecundariosErrors = getByLoginResponse.data && getByLoginResponse.data.id ? ['E-mail já cadastrado.'] : []
      } else {
        this.emailsSecundariosErrors = [getByLoginResponse.message]
      }
      this.loadingEmailsSecundarios = false
    } else {
      this.emailsSecundariosErrors = []
    }
  }

  @Watch('cadastroMedico.emailPrincipal')
  async onChangeCadastroMedicoEmailPrincipal(value) {
    if (validateEmail(value)) {
      this.loadingEmailPrincipal = true
      const getByLoginResponse = await SegurancaApi.getByLogin(value)
      if (getByLoginResponse.success) {
        this.emailPrincipalErrors = getByLoginResponse.data && getByLoginResponse.data.id ? ['E-mail já cadastrado.'] : []
      } else {
        this.emailPrincipalErrors = [getByLoginResponse.message]
      }
      this.loadingEmailPrincipal = false
    } else {
      this.emailPrincipalErrors = []
    }
  }

  @Watch('cadastroMedico.cpf')
  async onChangeCadastroMedicoCpf(value) {
    if (value.length === 11 && validateCPF(value)) {
      this.loadingCpf = true
      const request = await this.getCadastroMedicoStore.verificaSeExistePreCadastroMedicoHospital(value)
      if (!request.success) {
        this.loadingCpf = false
        this.cpfErrors = [request.message]
      } else {
        this.cpfErrors = []
      }
      this.loadingCpf = false
    } else {
      this.cpfErrors = []
    }
  }

  validateCpfField(cpfValue: any) {
    if (['', null, undefined].includes(cpfValue)) return 'Campo obrigatório.'
    if (!validateCPF(cpfValue)) return 'CPF inválido.'
    return false
  }

  removeEspecialidade(item: any) {
    this.cadastroMedico.cbos.splice(this.cadastroMedico.cbos.findIndex((cbo: any) => cbo.id === item.id), 1)
  }

  loadCpf: boolean = false
  get loadingCpf() { return this.loadCpf }
  set loadingCpf(value: boolean) { this.loadCpf = value }

  loadEmailPrincipal: boolean = false
  get loadingEmailPrincipal() { return this.loadEmailPrincipal }
  set loadingEmailPrincipal(value: boolean) { this.loadEmailPrincipal = value }

  loadEmailsSecundarios: boolean = false
  get loadingEmailsSecundarios() { return this.loadEmailsSecundarios }
  set loadingEmailsSecundarios(value: boolean) { this.loadEmailsSecundarios = value }

  loadSendCadastroMedico: boolean = false
  get loadingSendCadastroMedico() { return this.loadSendCadastroMedico }
  set loadingSendCadastroMedico(value: boolean) { this.loadSendCadastroMedico = value }

  get getBackofficeCadastroMedicoStore() {
    return getModule(BackofficeCadastroMedicoStore, this.$store)
  }

  get getCadastroMedicoStore() {
    return getModule(CadastroMedicoStore, this.$store)
  }

  get cbos() {
    return this.getBackofficeCadastroMedicoStore.cbos
  }

  get cadastroMedico() {
    return this.getBackofficeCadastroMedicoStore.cadastroMedicoBackoffice
  }

  async sendCadastroMedico() {
    this.loadingSendCadastroMedico = true

    if (this.$refs.formCadastro.validate()) {
      const response = await this.getBackofficeCadastroMedicoStore.sendCadastroMedico()
      if (response.success) {
        if (response.data.ehMedicoCadastrado) {
          this.getBackofficeCadastroMedicoStore.setModal({ name: 'cadastroMedicoAssociarCadastro', value: true })
          this.loadingSendCadastroMedico = false
          return
        }
        EventBus.$emit('setSnackbar', { show: true, text: 'Cadastro enviado com sucesso!', icon: 'done', color: '#2E7D32' })
        this.resetFormCadastro()
        await this.getBackofficeCadastroMedicoStore.getAllCadastrosMedicosByUsuarioHospital(this.getBackofficeCadastroMedicoStore.paginationMedicosCadastrados)
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: 'Ocorreu um erro ao enviar o cadastro.', icon: 'warning', color: '#C62828' })
      }
    }

    this.loadingSendCadastroMedico = false
  }

  mounted() {
    EventBus.$on('resetFormCadastro', () => this.resetFormCadastro())
  }
}
